// src/Pages/NematodeMapData.js

import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import './NematodeMapData.css';
import Header from '../Assets/Components/Header.js';
import Footer from '../Assets/Components/Footer.js';
import file from '../Assets/Data/NematodeMap/Bezerra_et_al_2026_Dataset.xlsx';

const NematodeMapData = () => {

  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);

  const MAX_ROWS = 689;
  const MAX_COLS = 21;

  useEffect(() => {
    fetch(file)
      .then((res) => res.arrayBuffer())
      .then((data) => {
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[1]];
        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // adjust this number to where "ID" actually starts
        const DATA_START_ROW = 5;

        const head = json[DATA_START_ROW];
        const body = json.slice(DATA_START_ROW + 1);

        setHeaders(head);
        setRows(body);


      });
  }, []);

  const visibleHeaders = headers.slice(0, MAX_COLS);
  const visibleRows = rows.slice(0, MAX_ROWS).map(row => row.slice(0, MAX_COLS));


  return (
    <div className='mapdata-page'>
      <Header />

        <div className='mapdata-header'>

          <div className='mapdata-hleft'>

          </div>

          <div className='mapdata-hcenter'>
            <div className='mapdata-title'>Dataset for Bezerra <i>et al.</i>, 2025</div>
          </div>

          <div className='mapdata-hright'>
            <a className='link' href='/downloadables/Bezerra_et_al_2026_Dataset.xlsx' download>
              <button className='download-btn'>Download the Dataset</button>
            </a>
          </div>
        </div>

      <div className='table-container'>
        <div className='scroll-table'>
          <table className='csv-table sticky-table'>
            <thead>
              <tr>
                {visibleHeaders.map((h, i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {visibleRows.map((row, i) => (
                <tr key={i}>
                  {headers.map((_, j) => (
                    <td key={j}>{row[j]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NematodeMapData;
